import React, { useState } from 'react';

const initialForm = {
  title: '',
  description: '',
  due_date: '',
  assigned_role: 'administradora',
  priority: 'media',
  category: 'administracion',
};

export const ClinicOperationsPanel = ({ workspace, onCreateTask, onUpdateTask, onOpenReport, saving }) => {
  const [form, setForm] = useState(initialForm);

  const submit = async (event) => {
    event.preventDefault();
    const success = await onCreateTask(form);
    if (success) setForm(initialForm);
  };

  return (
    <section className="grid gap-5 xl:grid-cols-[0.9fr_1.1fr]" data-testid="clinic-operations-panel">
      <form onSubmit={submit} className="rounded-[28px] border border-white/60 bg-white/95 p-5 shadow-[0_20px_60px_rgba(15,23,42,0.08)] sm:p-6" data-testid="clinic-operations-form">
        <p className="text-xs uppercase tracking-[0.24em] text-[#0f766e]">Operación diaria</p>
        <h2 className="mt-2 text-2xl font-black text-slate-900">Nueva tarea interna</h2>
        <div className="mt-5 space-y-4">
          <input data-testid="clinic-operations-title-input" className="w-full rounded-2xl border border-slate-200 px-4 py-3" placeholder="Ej. llamar paciente, pedir stock, revisar redes" value={form.title} onChange={(event) => setForm((prev) => ({ ...prev, title: event.target.value }))} required />
          <textarea data-testid="clinic-operations-description-input" className="min-h-[100px] w-full rounded-2xl border border-slate-200 px-4 py-3" placeholder="Descripción" value={form.description} onChange={(event) => setForm((prev) => ({ ...prev, description: event.target.value }))} />
          <div className="grid gap-4 sm:grid-cols-2">
            <input data-testid="clinic-operations-due-date-input" type="datetime-local" className="rounded-2xl border border-slate-200 px-4 py-3" value={form.due_date} onChange={(event) => setForm((prev) => ({ ...prev, due_date: event.target.value }))} />
            <select data-testid="clinic-operations-role-select" className="rounded-2xl border border-slate-200 px-4 py-3" value={form.assigned_role} onChange={(event) => setForm((prev) => ({ ...prev, assigned_role: event.target.value }))}>
              {[{ id: 'doctora', label: 'Doctora' }, { id: 'enfermera', label: 'Enfermera' }, { id: 'administradora', label: 'Administradora' }, { id: 'community_manager', label: 'Community Manager' }].map((role) => <option key={role.id} value={role.id}>{role.label}</option>)}
            </select>
          </div>
          <div className="grid gap-4 sm:grid-cols-2">
            <select data-testid="clinic-operations-priority-select" className="rounded-2xl border border-slate-200 px-4 py-3" value={form.priority} onChange={(event) => setForm((prev) => ({ ...prev, priority: event.target.value }))}>
              {['alta', 'media', 'baja'].map((priority) => <option key={priority} value={priority}>{priority}</option>)}
            </select>
            <select data-testid="clinic-operations-category-select" className="rounded-2xl border border-slate-200 px-4 py-3" value={form.category} onChange={(event) => setForm((prev) => ({ ...prev, category: event.target.value }))}>
              {['consulta', 'stock', 'seguimiento', 'contenido', 'administracion'].map((category) => <option key={category} value={category}>{category}</option>)}
            </select>
          </div>
          <div className="flex flex-wrap gap-2">
            <button data-testid="clinic-operations-submit-button" type="submit" className="rounded-full bg-slate-900 px-5 py-3 text-sm font-semibold text-white" disabled={saving === 'operation-create'}>
              {saving === 'operation-create' ? 'Guardando…' : 'Crear tarea'}
            </button>
            <button type="button" onClick={() => onOpenReport(workspace.report_export_urls?.operations)} className="rounded-full bg-[#dbeafe] px-5 py-3 text-sm font-semibold text-[#1d4ed8]" data-testid="clinic-operations-export-button">PDF operación</button>
          </div>
        </div>
      </form>

      <div className="space-y-4" data-testid="clinic-operations-list">
        {workspace.operation_tasks?.length ? workspace.operation_tasks.map((task) => (
          <article key={task.id} className="rounded-[28px] border border-white/60 bg-white/95 p-5 shadow-[0_16px_40px_rgba(15,23,42,0.06)]" data-testid={`clinic-operation-item-${task.id}`}>
            <div className="flex flex-col gap-3 md:flex-row md:items-start md:justify-between">
              <div>
                <p className="text-lg font-bold text-slate-900">{task.title}</p>
                <p className="mt-1 text-sm text-slate-600">{task.description || 'Sin descripción'}</p>
                <p className="mt-2 text-xs text-slate-500">{task.category} · {task.assigned_role} · {task.due_date || 'sin fecha'}</p>
              </div>
              <div className="flex flex-wrap gap-2">
                <span className="rounded-full bg-slate-100 px-3 py-1 text-xs font-semibold text-slate-600">{task.status}</span>
                <span className="rounded-full bg-amber-100 px-3 py-1 text-xs font-semibold text-amber-700">{task.priority}</span>
              </div>
            </div>
            <div className="mt-4 flex flex-wrap gap-2">
              <button type="button" onClick={() => onUpdateTask(task.id, { status: 'en_progreso' })} className="rounded-full bg-[#dbeafe] px-4 py-2 text-sm font-semibold text-[#1d4ed8]" data-testid={`clinic-operation-progress-${task.id}`}>En progreso</button>
              <button type="button" onClick={() => onUpdateTask(task.id, { status: 'hecha' })} className="rounded-full bg-[#dcfce7] px-4 py-2 text-sm font-semibold text-[#166534]" data-testid={`clinic-operation-done-${task.id}`}>Hecha</button>
            </div>
          </article>
        )) : <div className="rounded-[28px] border border-dashed border-slate-300 bg-white/80 p-8 text-sm text-slate-500" data-testid="clinic-operations-empty">Todavía no hay tareas diarias cargadas.</div>}
      </div>
    </section>
  );
};